import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPencil"><Path d="M16.5 1.93933L22.0607 7.49999L18.8107 10.75L13.25 5.18934L16.5 1.93933Z" fill="currentColor"/><Path d="M12.1893 6.25L2 16.4393V22H7.56066L17.75 11.8107L12.1893 6.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencil;
